import { NodeViewWrapper, type NodeViewProps } from "@tiptap/react";

import type { DocumentAttributes } from "../../nodes";
import { Button } from "@ui/Button";

export type IDocumentProps = NodeViewProps;

/* tslint:disable:no-unused-variable */
export const Document = ({ node, editor }: IDocumentProps) => {
  const attrs = node.attrs as DocumentAttributes;

  const handleOpenDocument = () => {
    if (attrs.uploading) return;
  };

  return (
    <NodeViewWrapper className="w-full">
      <div
        role="button"
        tabIndex={0}
        onClick={(ev) => {
          ev.preventDefault();
          const target = ev.target as HTMLElement;

          if (target.closest("button")) return;

          handleOpenDocument();
        }}
        className="not-prose m-auto mb-4 grid w-full max-w-4xl items-center gap-3 rounded-lg border border-stroke-primary px-4 py-3 text-left shadow-md"
      >
        {!attrs.uploading && attrs.show_preview && (
          <div className="relative -mx-4 -mt-3 h-56 flex-none overflow-hidden rounded-t-lg bg-slate-100">
            <img src={attrs.preview_url!} className="absolute inset-0 object-cover" />

            <div className="absolute right-3 top-3">
              <Button
                buttonType="SECONDARY"
                isIconOnly
                onClick={() => {
                  handleOpenDocument();
                }}
              >
                {/* <IconFullPage className="h-5 w-5" /> */}
                icon
              </Button>
            </div>
          </div>
        )}
      </div>
    </NodeViewWrapper>
  );
};
